/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./authorization-table-dialog.vue?vue&type=template&id=1cc04ce8&"
import script from "./authorization-table-dialog.vue?vue&type=script&lang=ts&"
export * from "./authorization-table-dialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports